"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const LoadingButton = (_a) => {
    var { loading, className, children } = _a, props = __rest(_a, ["loading", "className", "children"]);
    const classNames = (0, classnames_1.default)("flex items-center", "focus:outline-none", {
        "pointer-events-none bg-opacity-75 select-none": loading,
    }, className);
    return (react_1.default.createElement("button", Object.assign({ disabled: loading, className: classNames }, props),
        loading && react_1.default.createElement("div", { className: "mr-2 btn-spinner" }),
        children));
};
exports.default = LoadingButton;
